import React, { useEffect, useState } from "react";
// import { Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";

import "./styles.scss";

const PublicMessage = (props) => {
  const [message, setMessage] = useState(props.message);

  useEffect(() => {
    setMessage(props.message);
  }, [props.message]);

  if (message) {
    return (
      <div className="public-message">
        <div style={{ paddingRight: "1.5em" }}>{message}</div>
      </div>
    );
  } else {
    return null;
  }
};

export default withRouter(PublicMessage);
